module.exports = __webpack_public_path__ + "static/0072-ad889f7f4de399b1317999977e32713a.png";